import { Component, OnInit, ElementRef, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { Meta } from '../common/seo.service';
import { ActivatedRoute } from '@angular/router';
import { FillerService } from '../common/Service_tnFiller';
import * as myGlobals from '../global';
import { SafeResourceUrl, 
         DomSanitizer, BrowserModule  } from '@angular/platform-browser';
import { SiteConfigurationService } from '../common/site-configuration.service'; 

import { Http } from '@angular/http';

import { TnGoogleMap } from '../components/tngooglemap/tngooglemap.component';
import * as myLanguages from '../common/vars_translate';

import { FormGroup, FormControl, Validators } from '@angular/forms';

//import { AgmCoreModule } from 'angular2-google-maps/core';

// jQuery Sign $
declare let $: any;
declare let window: any;

declare var google: any;

@Component({
  selector: 'app-detail',
  templateUrl: '../themes/default/html/detail.component.html',
  styleUrls: ['../themes/default/css/detail.component.scss']
})
export class DetailComponent implements OnInit {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;

  Contact = {
    Form: { 
      Title: 'Richiedi informazioni',
      Email: 'Indirizzo email',
      FullName: 'Digita il tuo nome e cognome',
      Number: 'il tuo recapito telefonico',
      Desc:'Richiesta',
      UiCulture:'it'
    },
    Button: 'Invia Richiesta'
  }

   contactFields = { 
      adsCode: '',
      email: '',
      fullName: '',
      message: '',
      phone: '',
      uiCulture: 'it'
    }

  contactForm: any;
  SingleAd = [];

  public GeoData: any;

  // google maps zoom level
  zoom: number = 8;
  
  // initial center position for the map
  lat: number = 51.673858;
  lng: number = 7.815982;

  DetailId: any; 
  _mySettings: any; 
  backgroundImg: any;

  public Advertisement: any = {
    ExtraData: '',
    Geo: {},
    Links: []
  };
  ImagesList= [];
  adDataTitle: any; 

  GeoAddress: any;
  Extradata: any = {
    priceTable: {
      headers: [],
      items: []
    }
  };

  initdone = false;
  
  infoPrivacy: any = '';

  adLinks: Array<any> = [];

  filespath: string = '';

  constructor(private myMeta: Meta, private route: ActivatedRoute, private filler: FillerService, 
  public sanitizer: DomSanitizer, private mySettings: SiteConfigurationService, private elementRef:ElementRef,
  private cfr: ComponentFactoryResolver, public http: Http ) {    
    
    console.log('Detail: Constructor');

    this._mySettings = mySettings.getFullConfig();
    this.SingleAd = Object.assign([],myLanguages.translations_IT.SingleAd);

	this.filespath = myGlobals.apiBasePath;
    // this.route.params.subscribe(params => {
    //     this.DetailId = params['id'];
    // }); 

    // this.getContetnt();
    
    
  }
  getContetnt() {

    var payload = {};
    payload = JSON.stringify({code: this.DetailId, uiCulture: 'it'});

    new Promise((resolve, reject) => {
      this.filler.Get_Advertisement(payload).subscribe(
          data => {
            
            try {
              this.Advertisement = Object.assign([], data);
              //console.table(data);
            } catch (e) {
                console.log('LOCAL ERROR:' );
            }
            
            
            if (data.ExtraData != undefined || data.ExtraData != null) {
              if (data.ExtraData !='') {
                this.Extradata = JSON.parse(data.ExtraData);
              }
            }

            resolve(true);
          }, err => { console.log('LOCAL ERROR: ' + err) }
        );
    }).then(
      e => {
        // aggiorna la data
        this.Advertisement.Date = this.Advertisement.Date * 1000;

        this.ImagesList = JSON.parse(this.Advertisement.Images);
        
        for (let singleImage of this.ImagesList) {
          singleImage.url == '' ? singleImage.url = myGlobals.apiBasePath + this._mySettings.e400.images.noAdsImagePlaceHolder : singleImage.url = myGlobals.apiBasePath +  singleImage.url;        
        }

        this.contactFields.adsCode = this.Advertisement.Code;

        this.GenerateTitle();
        this.GenerateGeoAddress();
        // myMeta.setTitle(this.adDataTitle);
		this.CreateReference();
		
		this.adLinks = JSON.parse(this.Advertisement.Links);

      }
    );
    
    new Promise((resolve, reject) => {
      this.filler.Get_Privacy().subscribe(
          data => {
            this.infoPrivacy = Object.assign([], data)
            resolve(true);
          }, err => { console.log(err) }
        );
    }).then(
      e => console.log('Done with privacy')
    );
  }

  ngOnInit() {
    // var directionsService = new google.maps.DirectionsService;
    // var directionsDisplay = new google.maps.DirectionsRenderer;
    // var map = new google.maps.Map(document.getElementById('map'), {
    //   zoom: 7,
    //   center: {lat: 41.85, lng: -87.65}
    // });
    // directionsDisplay.setMap(map);
    //calculateAndDisplayRoute(directionsService, directionsDisplay);

        
  }
  upFirst(value){
    return value.charAt(0).toUpperCase() + value.slice(1);
}

  ngAfterViewChecked(){
  
    let paramID ='';

    this.route.params.subscribe(params => {

      paramID = params['id'];
      if (paramID != '' && paramID != this.DetailId ){
        this.DetailId = params['id'];
        this.getContetnt();
      }
    
  }); 

  }

  checkIsTextType = function (idx) {
      if (this.Extradata.priceTable.headers[idx].type === 'string') {
          return true;
      } else {
          return false;
      }
  };
  checkIsDateType = function (idx) {
      if (this.Extradata.priceTable.headers[idx].type === 'dateTime') {
          return true;
      } else {
          return false;
      }
  };
  checkIsCurrencyType = function (idx) {
      if (this.Extradata.priceTable.headers[idx].type === 'currency') {
          return true;
      } else {
          return false;
      }
  };
  checkIsNumberType = function (idx) {
      if (this.Extradata.priceTable.headers[idx].type === 'number') {
          return true;
      } else {
          return false;
      }
  };

  GenerateTitle() {

    if (this.Advertisement.Hierarchy[0].TypeName) { this.adDataTitle = this.Advertisement.Hierarchy[0].TypeName; }
    if (this.Advertisement.GroupAlias) {            this.adDataTitle += ' in ' + this.Advertisement.GroupAlias; }
    if (this.Advertisement.Geo.Aa3) { this.adDataTitle += ' a ' + this.Advertisement.Geo.Aa3; this.adDataTitle += ' (' + this.Advertisement.Geo.Aa2 + ')'; }
    
    var tmpTitle = '';

    try
    {
      tmpTitle = JSON.parse(this.Advertisement.Geo.Extra).label;
    } catch (e) {
      tmpTitle = '';
    }

    if (tmpTitle) { this.adDataTitle += ' in ' + tmpTitle; }

  }

  GenerateGeoAddress() {

    var tmpTitle = '';

    try
    {
      tmpTitle = JSON.parse(this.Advertisement.Geo.Extra).label;
    } catch (e) {
      tmpTitle = '';
    }

    tmpTitle += ' ' + this.Advertisement.Geo.Aa3 + ' (' + this.Advertisement.Geo.Aa2 + ')'; // AIzaSyBviSL2wtnnSFgDdVbgJkTlogZpCaegu4U
    
    this.GeoAddress = '' + tmpTitle;
    this.putInHTML(this.GeoAddress);

  }

  putInMyHtml(p) {
   // this.target.clear();

    let compFactory = this.cfr.resolveComponentFactory(TnGoogleMap);

    let ref = this.target.createComponent(compFactory);
    ref.instance.geolocationaddress = p;
  }

  putInHTML(p) {

    var s;
    try {
        s = document.getElementById('googleMap');
    } catch (e) {
        return;
    }
    
    //let compFactory = this.cfr.resolveComponentFactory(TnGoogleMap);
    // s.InnerHTML = 'questo è un test';
    // s.value = 'ciao';

    var destinationURL = 'https://www.google.com/maps/embed/v1/place?key=';
    var destinationKey = 'AIzaSyBviSL2wtnnSFgDdVbgJkTlogZpCaegu4U';
    var framesrc = destinationURL + destinationKey + '&q=' + p;

    var gm = document.createElement('iframe');
    gm.width = '100%';
    gm.height='100%';
    gm.frameBorder='0';
    //gm.className = 'tngooglemap';
    gm.src = framesrc;

    s.appendChild(gm);

  }

  CreateReference() {

    var s;
    try {
        s = document.createElement("script");
    } catch (e) {
        return;
    }
    //s.id = "SwipererBig";
    s.type = "text/javascript";
    s.src="./assets/script.js";
    this.elementRef.nativeElement.appendChild(s);
    
    this.initdone = true;
    if (this.initdone) { return; }

}

  sendEmail() {
    console.log('Invio email in corso');
    var emailReq =  Object.assign([], this.contactFields)
    this.filler.Send_EmailAdvertisement(this.contactFields).subscribe(
      data => { 
        console.log(data);
      }
    )
  }

	// stampa la scheda immobile corrente
	toPrint() {

		let replacedHTML = '';
		//replacedHTML =  $("#printTemplate").html();

		// recupera html del modello
		this.http.get('assets/printTemplate.html').subscribe(data => {
                
			replacedHTML = data["_body"];

		}, (err) => {

			replacedHTML = '';

		},
		() => {

			this.backgroundImg = myGlobals.apiBasePath + '/' + this._mySettings.e400.site.logo;
      console.log(this.backgroundImg);
	
			//this.backgroundImg = this.sanitizer.bypassSecurityTrustUrl(this.backgroundImg);
			

			replacedHTML = replacedHTML.replace("[LOGO]", this.backgroundImg);
			replacedHTML = replacedHTML.replace("[INFO AGENZIA]", this._mySettings.e400.backOffice.print.company);
			//"Eureka Immobiliare<br/>P.zza della Libertà, 24 - Gaeta LT<br/>P.I 02336900598<br/>Tel/Fax  0771 464148<br/>Cell 347 1102125<br/>info@eurekaimmobili.com");

			replacedHTML = replacedHTML.replace("[TITOLO]", "<h2 class=\"page-title\">" + this.adDataTitle + "</h2>");

			replacedHTML = replacedHTML.replace("[FOTO 1]", myGlobals.apiBasePath + '/' + JSON.parse(this.Advertisement.Images)[0].url);
			replacedHTML = replacedHTML.replace("[FOTO 2]", myGlobals.apiBasePath + '/' + JSON.parse(this.Advertisement.Images)[1].url);

			replacedHTML = replacedHTML.replace("[CODICE]","<span class=\"adv-code\">" + this.Advertisement.Code + "</span>");
			
			if (this.Advertisement.Price > 0) { 
				replacedHTML = replacedHTML.replace("[PREZZO]","€ " + this.Advertisement.Price);
			} else {
				replacedHTML = replacedHTML.replace("[PREZZO]","POA");
			}
			
			const objTableList = $('#pricesTable').html();

			replacedHTML = replacedHTML.replace("[INFOCATEGORIA]", this.Advertisement.Hierarchy[0].CategoryName)
			.replace("[INFOMQINTERNI]", this.Advertisement.InternalMq)
			.replace("[INFOMQESTERNI]", this.Advertisement.ExternalMq)
			.replace("[INFORISCALDAMENTO]", this.Advertisement.HasRadiator == true ? 'Si' : 'No')
			.replace("[INFOCONDIZIONATORE]", this.Advertisement.HasConditioner == true ? 'Si' : 'No')
			.replace("[INFOASCENSORE]", this.Advertisement.HasLift == true ? 'Si' : 'No')
			.replace("[INFOPANORAMICO]", this.Advertisement.IsPanoramic == true ? 'Si' : 'No')
			.replace("[INFOANIMALI]", this.Advertisement.IsAnimaladmit == true ? 'Si' : 'No')
			.replace("[INFOTIPOLOGIA]", this.Advertisement.Hierarchy[0].TypeName)
			.replace("[INFOCLASSE]", this.Advertisement.EnergyClass)
			.replace("[INFOIPE]", this.Advertisement.Ipe)
			.replace("[INFOPIANO]", this.Advertisement.Floor)
			.replace("[INFONUMEROPIANI]", this.Advertisement.BuildFloorsTotal)
			.replace("[INFOPARCHEGGI]", this.Advertisement.CarPark)
			.replace("[INFOLOCALI]", this.Advertisement.Rooms)
			.replace("[INFOBAGNI]", this.Advertisement.Bathrooms)
			.replace("[TABELLAPREZZI]", objTableList == undefined ? '' : objTableList);


			replacedHTML = replacedHTML.replace("[DESCRIZIONE]", "<p>" + this.Advertisement.Description + "</p>");
			
			// const $outContent = $('<div class="testoutprinter">').append(replacedHTML);

			if (this.Advertisement.Geo.Locality !== '') {
				
				// const $mapContainer = $('#advgoogleMap'); 

				// const $printContainer = $outContent.find('#printMap');

				// $printContainer
				// 	.height($mapContainer.height())
				// 	.append($mapContainer);
				
				// $outContent.append($printContainer);	Brooklyn+Bridge,New+York,NY
				const maplocation = "https://maps.googleapis.com/maps/api/staticmap?center=" + JSON.parse(this.Advertisement.Geo.Extra).label + ' ' + this.Advertisement.Geo.Aa3 + ' (' + this.Advertisement.Geo.Aa2 + ')' + "&zoom=16&size=440x350&maptype=roadmap&key=AIzaSyBviSL2wtnnSFgDdVbgJkTlogZpCaegu4U";
				replacedHTML = replacedHTML.replace("[MAPPA]", maplocation );
				// replacedHTML = replacedHTML.replace("[MAPPA]",  $('#advgoogleMap').html());
			}
			
      
			//$("#innerPrintPreview").empty().append(replacedHTML); //.html(replacedHTML);
			$("#hidden-print-div").empty().append(replacedHTML); //.html(replacedHTML);
			
						
			this.printOutput();
					
		});

		
	}

	printOutput() {

		// $('app-root').css({"display" : "none"});
		// $("#hidden-print-div").css({"display" : "block"});
    $('app-root').addClass('hidden');
    $("#hidden-print-div").removeClass('hidden');

		setTimeout(() => {
			window.print();
			// $("#hidden-print-div").css({"display" : "none"});
			// $('app-root').css({"display" : "block"});
      $('app-root').removeClass('hidden');
      $("#hidden-print-div").addClass('hidden');
		}, 2500);

	}


}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/detail/detail.component.ts